import { AssetSvgProps } from "../../../shared/assets"

function ShiMot067({ className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill="#0280D2"
                    d="M159.2 257.85v17.9q33.25 5.86 66.5 0v-17.9h-66.5z"
                    id="ShiMot067__Layer5_0_FILL"
                />
                <path
                    fill="#FF0"
                    d="M159.2 275.75v17.85h66.5v-17.85h-66.5z"
                    id="ShiMot067__Layer5_1_FILL"
                />
            </defs>
            <use xlinkHref="#ShiMot067__Layer5_0_FILL" />
            <use xlinkHref="#ShiMot067__Layer5_1_FILL" />
        </g></g>
    )
}

export default ShiMot067
